var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('operational-area',{attrs:{"show":Object.assign({}, _vm.show,
        {screen: _vm.loading}),"screen":{
        settings: {
            toggles: {
                request: _vm.show.request
            },
            loading: true
        }
    },"init":_vm.initSupervise,"closeAction":_vm.closeSupervise},scopedSlots:_vm._u([{key:"operational__area",fn:function(){return [_c('div',{staticClass:"supervise"},[_c('transition',{attrs:{"name":"fade","mode":"out-in"}},[(_vm.show.calls)?_c('div',{staticClass:"supervise__call"},[_c('h2',{staticClass:"supervise__title color--green capitalize"},[_vm._v(_vm._s(_vm.$t('global.callsInProgress')))]),_c('base-card',{staticClass:"supervise__table",attrs:{"add-margins":false},scopedSlots:_vm._u([{key:"card__body",fn:function(){return [_c('base-table',{staticClass:"supervise__table__content",attrs:{"headers":[
                                    'operator',
                                    'recipient',
                                    'contact',
                                    'campaign',
                                    'state'
                                ],"list":_vm.list,"model":"request","settings":{
                                    component: 'RowRequests',
                                    removeMargin: true,
                                    maxHeight: '665px',
                                    warning: _vm.$t('global.callsInProgress')
                                }},on:{"intercept-call":_vm.initCall}})]},proxy:true}],null,false,2009061436)})],1):_c('call-area',{attrs:{"settings":{ data: _vm.data, call: _vm.call, workflow: 'intercept' }},on:{"show-calls":_vm.showCalls}})],1)],1)]},proxy:true}])})}
var staticRenderFns = []

export { render, staticRenderFns }